import React, { useMemo } from 'react';
import styled from 'styled-components';

import { RatingsData } from 'apis/merchant-gateway/insights';
import { LegendChartType, Legends, VerticalBarChart } from 'modules/experience-core';

type RatingsChartProps = {
  legends: Legends<'positiveRatings' | 'negativeRatings' | 'averageRating'>;
  data: RatingsData<string>[];
  summaryKey: string;
};

const RatingsChartContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 24px 16px;
`;

export const RatingsChart = ({ legends, data, summaryKey }: RatingsChartProps) => {
  const chartData = useMemo(() => {
    return data.map(item => {
      const { label, total } = item;
      const { averageRating, positiveRatings, negativeRatings } = total;
      return {
        positiveRatings,
        negativeRatings,
        averageRating,
        name: label || '',
      };
    });
  }, [data]);

  return (
    <RatingsChartContainer>
      <VerticalBarChart
        legends={legends}
        isStacked
        data={chartData}
        summaryKey={summaryKey}
        axisDomains={{
          [LegendChartType.LINE]: [0, 10],
        }}
        axisIntegerOnly={{
          [LegendChartType.BAR]: true,
        }}
      />
    </RatingsChartContainer>
  );
};
